import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#003366', // Azul Escuro
    },
    secondary: {
      main: '#66CC99', // Verde Claro
    },
    background: {
      default: '#FFF',
    },
    text: {
      primary: '#001F3F', // Deep Navy (pode ser ajustado para melhor contraste)
      secondary: '#FFFFFF', // Branco (para textos sobre fundo Azul Escuro)
    },
  },
  typography: {
    fontFamily: 'Open Sans, Arial, sans-serif',
    h1: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 500,
    },
    h4: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 400,
    },
    h5: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 400,
    },
    h6: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 400,
    },
    body1: {
      fontFamily: 'Open Sans, Arial, sans-serif',
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.primary,
          '&.Mui-focused': {
            color: theme.palette.primary.main,
          },
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: ({ theme }) => ({
          '&::placeholder': {
            color: theme.palette.text.primary,
            opacity: 1,
          },
        }),
      },
    },
    // Estilos adicionais para outros componentes (opcional)
    // Exemplo:
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: '8px',
    //     },
    //   },
    // },
  },
});

export default theme;